import { render, staticRenderFns } from "./NewValidatedForm.vue?vue&type=template&id=013bf7c0&scoped=true&"
import script from "./NewValidatedForm.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NewValidatedForm.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./NewValidatedForm.vue?vue&type=style&index=0&id=013bf7c0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013bf7c0",
  null
  
)

export default component.exports